import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

import history from '../utils/history';
import * as sinisterCardsActions from '../redux/actions/sinister-cards';
import * as http from '../utils/http';
import { checkIfHotjarEnable, dynaTraceGetAction, dynaTraceLeaveAction, formatDateReverse, timeBetweenDates } from '../utils/helpers';
import RimacTopBar from '../components/common/RimacTopBar/RimacTopBar';
import Navbar from '../components/common/Navbar/Navbar';
import InfoCard from '../components/content/InfoCard/InfoCard';
import Modal from '../components/common/modal/Modal';
import RimacFooter from '../components/common/RimacFooter/RimacFooter';
import ImgLoader from '../assets/ilu_center_loader.svg';
import IconEdit from '../assets/icon_edit_gray.svg';
import IconWarning from '../assets/ic_warning.svg';
import IconCheckGreen from '../assets/ic_check_green.svg';
import { PAGINAS_BY_STEP } from '../utils/constants';
import { setErrorCode } from '../redux/actions/coverage';

const ValidateInfoPage = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.sinisterCards.userInfo);
   const advisorInfo = useSelector( (state) => state.sinisterCards.advisorInfo)
  const accountInfo = useSelector((state) => state.sinisterCards.accountInfo);
  // const totalSoles = useSelector((state) => state.sinisterCards.totalSoles);
  // const totalDollars = useSelector((state) => state.sinisterCards.totalDollars);
  const sinisterList = useSelector((state) => state.sinisterCards.sinisterList);
  const sinisterFiles = useSelector(
    (state) => state.sinisterCards.sinisterFiles
  );
  const sinisterDate = useSelector((state) => state.sinisterCards.sinisterDate);
  const otherInsurance = useSelector(
    (state) => state.sinisterCards.otherInsurance
  );
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [currentSinisterClick, setCurrentSinisterClick] = useState(null);
  const [viewStartTime, setViewStartTime] = useState(new Date());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    return () => {
      const endTime = new Date();
      const userTotalTime = timeBetweenDates(viewStartTime, endTime);

      if (checkIfHotjarEnable()) {
        window.digitalData.push({
          task: {
            name: 'Tiempo registrado - Resumen',
            time: userTotalTime,
          },
          event: 'trackTimeToComplete',
        });
      }
    };
  }, []);

  const onClickSinisterEdit = (sinister) => {
    if (checkIfHotjarEnable()) {
      window.digitalData.push({
        action: {
          group: 'Tramites Siniestros – Protección Tarjeta BBVA',
          category: 'Confirmación',
          name: 'Validar información',
          label: sinister.title,
        },
        event: 'trackAction',
      });
    }

    dispatch(sinisterCardsActions.setStep(3));
    history.replace(`/montos-robados#${sinister.code}`);
  };

  const onClickSinisterDelete = () => {
    const updatedList = sinisterList.filter(
      (sr) => sr.code !== currentSinisterClick
    );
    dispatch(sinisterCardsActions.updateSinisterList(updatedList));
    dispatch(sinisterCardsActions.setSinister(updatedList.length - 1));
    setOpenDeleteModal(false);
  };

  const onBackHandler = () => {
    dispatch(sinisterCardsActions.reduceStep());
    history.replace('/info-reembolso');
  };

  const onSendSinisterHandler = async () => {
    console.log('finishing...');

    // send all to backend
    setLoading(true);
    const action = dynaTraceGetAction('click send form button');

    const realDate = new Date(sinisterDate);
    const month = String(realDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(realDate.getUTCDate()).padStart(2, '0');
    const year = realDate.getUTCFullYear();
    const formatedDate = `${day}/${month}/${year}`;

    const subTipoDocumentos = [];
    sinisterFiles.forEach((sFile) => {
      sFile.files.forEach((file) => {
        subTipoDocumentos.push({
          tipo: sFile.typeFile,
          extension: String(file.name.split('.').pop()).toLowerCase(),
          content: file,
        });
      });
    });

    const subTipoDocumentosInfo = subTipoDocumentos.map((file) => {
      return {
        tipo: file['tipo'],
        extension: file['extension'],
      };
    });

    const name = userInfo.name
      .split(' ')
      .filter((el) => el !== '')
      .join(' ');
    const fatherLastName = userInfo.fatherLastName
      .split(' ')
      .filter((el) => el !== '')
      .join(' ');
    const motherLastName = userInfo.motherLastName
      .split(' ')
      .filter((el) => el !== '')
      .join(' ');

    const docPayload = {
      data: {
        aseguradoDetalle: {
          tipoDocumento: userInfo.documentType.value,
          numeroDocumento: userInfo.document,
          nombre: name,
          apellidoPaterno: fatherLastName,
          apellidoMaterno: motherLastName,
        },
        subTipoDocumentos: subTipoDocumentosInfo,
        fechaSiniestro: formatedDate,
      },
    };

    const sinisters = sinisterList.map((sinister) => {
      return {
        nombre: sinister.code,
        montoSoles: Number(sinister.soles),
        montoDolares: Number(sinister.dollars || 0),
      };
    });

    try {
      const docs = await http.post(
        '/documentos',
        docPayload,
        process.env.REACT_APP_API_NAME
      );
      const { ideSiniestro } = docs.payload;

      await Promise.all(
        docs.payload.documentos.map(async (el, i) => {
          let blob = await fetch(subTipoDocumentos[i].content.content).then(
            (r) => r.blob()
          );
          const newFile = new File([blob], subTipoDocumentos[i].content.name);
          await axios.put(el.url, newFile, {
            headers: {
              'Content-Type': subTipoDocumentos[i].content.type,
            },
          });
        })
      );
      const refundAccounts = accountInfo
        .filter((el) => el.cci !== '')
        .map((el) => {
          return {
            cciReembolso: el.cci,
            bancoReembolso: el.bank.payloadValue,
            tipoCuentaReembolso: el.accountType.value,
            moneda: el.currency,
          };
        });

      const proteccionTarjetasOtros =
        otherInsurance.otherInsurance === 'si' ? 'SI' : 'NO';
      const proteccionTarjetasCobertura =
        otherInsurance.coverage === 'si' ? 'SI' : 'NO';

      const sinisterPayload = {
        siniestro: {
          ideSiniestro: ideSiniestro,
          persona: {
            tipoDocumento: userInfo.documentType.value,
            numeroDocumento: userInfo.document,
            nombre: name,
            apellidoPaterno: fatherLastName,
            apellidoMaterno: motherLastName,
            departamento: userInfo.department.text,
            correo: userInfo.email,
            celular: userInfo.phone,
          },
          coberturas: sinisters,
          fechaSiniestro: formatedDate,
          cuentasReembolso: refundAccounts,
          proteccionTarjetasOTros: proteccionTarjetasOtros,
          solicitoCoberturaMismoSiniestro: proteccionTarjetasCobertura,
        },
      };
      if (advisorInfo) {
        sinisterPayload.siniestro.asesor = {
          nombre: advisorInfo.text || '',
          email: advisorInfo.email || '',
          codigo: advisorInfo.value || '',
          fechaLlamada: formatDateReverse(advisorInfo.date || new Date()),
        }
      }

      await http.post(
        '/siniestros',
        sinisterPayload,
        process.env.REACT_APP_API_NAME
      );

      if (checkIfHotjarEnable()) {
        sinisterList.forEach((sinister) => {
          window.digitalData.push({
            metadata: {
              key: 'Tipo de siniestro - Protección Tarjeta BBVA',
              value: sinister.title,
            },
            event: 'trackMetadata',
          });
        });

        window.digitalData.push({
          event: 'trackRegisterSinisterBbvaCardProtection',
        });
      }

      setLoading(false);
      dynaTraceLeaveAction(action);
      dispatch(sinisterCardsActions.resetState());
      dispatch(sinisterCardsActions.setStep(PAGINAS_BY_STEP.THANKYOU.step));
      history.replace('/gracias');
    } catch (err) {
      console.log(err);
      setLoading(false);
      dispatch(sinisterCardsActions.resetState());
      if (err.code === 'ERR_NETWORK' || [504].includes(err?.response?.status)) {
        dispatch(setErrorCode(504))
      }
      history.replace('/error');
    }
  };

  return (
    <>
      <RimacTopBar />
      {!loading ? (
        <div
          data-testid="validate-info-page"
          className="validateInfoPage pageContainer"
        >
          <div className="validateInfoPage__left pageContainer__left">
            <div className="titleCont">
              <h1 className="u-mb-24">Seguro de Protección de Tarjetas</h1>
              <p>
                Hola, sabemos que sufriste un siniestro y queremos ayudarte a
                reportarlo.
              </p>
            </div>
          </div>
          <div className="validateInfoPage__right pageContainer__right">
            <div className="titleCont">
              <h3 className="u-mb-16">Validemos tu información</h3>
            </div>

            <section className="requestsSection u-mb-40">
              <h4 className="requestsSection__title">Estas reportando:</h4>
              <div className="requestsSection__list">
                {sinisterList.map((sinister) => (
                  <div
                    className={`requiredSinister u-mb-16`}
                    key={'sinister-' + sinister.code}
                  >
                    <div className="requiredSinister__card">
                      <img src={sinister.icon} alt="siniestro 1" />
                      <p>{sinister.title}</p>
                    </div>
                    <div className="requiredSinister__btnCont">
                      <button
                        className="iconBtn"
                        onClick={() => onClickSinisterEdit(sinister)}
                      >
                        <span className="iconBtn__icon">
                          <img src={IconEdit} alt="icon" />
                        </span>
                        <p>EDITAR</p>
                      </button>

                      {/* <button
                      className="iconBtn"
                      onClick={() => {
                        setOpenDeleteModal(true);
                        setCurrentSinisterClick(sinister.code);
                      }}
                      disabled={sinisterList.length <= 1}
                    >
                      <span className="iconBtn__icon">
                        <img src={IconDelete} alt="icon" />
                      </span>
                      <p>ELIMINAR</p>
                    </button> */}
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="infoSection u-mb-40">
              <div className="infoSection__left">
                <h5 className="infoSection__title">Tus datos son:</h5>
                <div className="infoSection__content">
                  <div className="info">
                    <p className="info__title">Teléfono</p>
                    <p>{userInfo.phone}</p>
                  </div>
                  <div className="info">
                    <p className="info__title">Correo</p>
                    <p>{userInfo.email}</p>
                  </div>
                </div>
              </div>
              <div className="infoSection__right"></div>
            </section>

            <section className="infoSection u-mb-40">
              <div className="infoSection__left">
                <h5 className="infoSection__title">
                  Tus documentos cargados son:
                </h5>
                <ul className="infoSection__docList">
                  {sinisterFiles.map((file, i) => (
                    <li key={'file-list' + i}>
                      <img src={IconCheckGreen} alt="icono check" />
                      <span className="itemText">{file.title}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="infoSection__right"></div>
            </section>

            <section className="infoSection u-mb-40">
              <div className="infoSection__left">
                <h5 className="infoSection__title">Tus datos bancarios son:</h5>
                <div className="infoSection__content">
                  {accountInfo.map((account, i) => {
                    if (account.bank) {
                      return (
                        <div
                          key={'bank-list' + i}
                          className="info info--column"
                        >
                          <p className="info__title">
                            Banco {account.bank.text}
                          </p>
                          <p>
                            {account.accountType.text}{' '}
                            {account.currency === 'PEN' ? 'soles' : 'dólares'}
                          </p>
                          <p>CCI: {account.cci}</p>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
              <div className="infoSection__right"></div>
            </section>

            <section className="infoSection u-mb-40">
              <div className="infoSection__left">
                <h5 className="infoSection__title">
                  Montos reportados del siniestro:
                </h5>
                <ul className="infoSection__content">
                  {sinisterList.map((sinister) => (
                    <li
                      key={'info_' + sinister.code}
                      className="info info--column"
                    >
                      <p className="info__title">{sinister.title}</p>
                      {Number(sinister.soles) > 0 && (
                        <p>{`Soles: S/${sinister.soles}`}</p>
                      )}
                      {Number(sinister.dollars) > 0 && (
                        <p>{`Dólares: $${sinister.dollars}`}</p>
                      )}
                      <p className="info__gray">{sinister.amountInfo}</p>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="infoSection__right"></div>
            </section>

            <InfoCard
              icon={IconWarning}
              content={
                <p>
                  <b>Al hacer clic en el botón "Finalizar" confirmas que </b>
                  la información provista es cierta y tiene carácter de
                  declaración jurada. Asimismo, estás aceptando la presentación
                  de tu solicitud de siniestro a través de este formulario
                  digital.
                </p>
              }
            />
          </div>

          <Modal
            onLabelClosed={true}
            visible={openDeleteModal}
            onToggle={() => setOpenDeleteModal(false)}
            className={openDeleteModal ? 'remove-modal-main' : ''}
            onLabelTextClosed=""
          >
            <div className="remove-modal-main__info">
              <div className="remove-modal-main__info-container">
                <h1>¡Eliminar monto registrado!</h1>
                <hr />
                <div className="remove-modal-main__info-content">
                  <p>
                    ¿Estás seguro que deseas eliminar el monto registrado de tu
                    lista?
                  </p>
                </div>
              </div>
              <div className="remove-modal-main__info-actions">
                <div className="remove-modal-main__info-button">
                  <button
                    className="remove-modal-main__info-button--outlined"
                    onClick={() => setOpenDeleteModal(false)}
                  >
                    No, cancelar
                  </button>
                </div>
                <div className="remove-modal-main__info-button">
                  <button
                    className="remove-modal-main__info-button--base"
                    onClick={onClickSinisterDelete}
                  >
                    SI, ELIMINAR
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          <Navbar
            navActive
            onContinueClick={onSendSinisterHandler}
            onBackClick={onBackHandler}
            currentStep={5}
            totalSteps={5}
            btnText="Finalizar"
            isLoading={loading}
          />

          <div className="spacingLeft"></div>
        </div>
      ) : (
        <>
          <div className="loadingPage">
            <section className="loadingPage__cont">
              <img
                className="loadingPage__img"
                src={ImgLoader}
                alt="Rimac cargando"
              />
              <h1 className="loadingPage__title">
                ¡Danos un momento! Estamos procesando{' '}
                <span className="u-txt-color-red">tu solicitud.</span>
                <br />
                <b>No cierres esta ventana.</b>
              </h1>
            </section>
          </div>
          <RimacFooter isAppInfoActive={false} />
        </>
      )}
    </>
  );
};

export default ValidateInfoPage;
